import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, TextField } from "@mui/material";
import { useEffect, useReducer, useState } from "react";
import api, { ProductDto, ProductUpdateDto } from "../../../api";
import { TokensControl } from "../../controls";
import { createStateReducer, notif, tryParseInt } from "../../utils";

export interface ProductDialogProps {
  product: Partial<ProductUpdateDto> | null;
  onSubmit?: (dto: ProductDto | null, action: "updated" | "closed") => void;
}

export const ProductDialog = (props: ProductDialogProps) => {
  const { product, onSubmit } = props;
  const [open, setOpen] = useState(false);
  const reducer = createStateReducer<ProductUpdateDto>();
  const [state, dispatch] = useReducer(reducer, null);

  const handleAccept = async () => {
    try {
      if (state?.id) {
        const product = await api.product.update(state as any);
        if (onSubmit) onSubmit(product, "updated");
      }
      setOpen(false);
    } catch (err) {
      notif(err, "error");
    }
  };
  const handleClose = () => {
    if (onSubmit) onSubmit(null, "closed");
    setOpen(false);
  };

  useEffect(() => {
    if (product !== null) {
      dispatch({ state: product, replace: true });
      setOpen(true);
    }
  }, [product]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm">
      <DialogTitle>{"EDIT PRODUCT"}</DialogTitle>
      <DialogContent dividers>
        <FormGroup sx={{ minWidth: 300 }}>
          <TextField label="SKU" required variant="standard" value={state?.sku ?? ""} onChange={(e) => dispatch({ state: { sku: e.target.value } })} />
          <TextField label="Quantity" variant="standard" type="number" value={"" + state?.quantity ?? ""} onChange={(e) => dispatch({ state: { quantity: tryParseInt(e.target.value, 0) } })} />
          <FormControlLabel label="Discontinued" control={<Checkbox checked={state?.isDiscontinued ?? false} onChange={(e, c) => dispatch({ state: { isDiscontinued: c } })} />} />
          <Divider />
          <br />
          <FormControl component="fieldset">
            <FormGroup>
              <TokensControl tokens={state?.tokens ?? []} onChange={(tokens) => dispatch({ state: { tokens } })} />
            </FormGroup>
          </FormControl>
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAccept}>Accept</Button>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};
